/**
 * ANB LiveChat Controlled Loader
 * Loads LiveChat on first interaction, home bottom, idle, or ?chat=1
 */

(function() {
  if (window.__lc_loader_installed) return;
  window.__lc_loader_installed = true;

  function canLoad() {
    return !!(window.__lc && window.__lc.license);
  }

  function load(reason) {
    if (window.__lc_loaded) return;
    if (!canLoad()) {
      try { console.warn('[LiveChat] Missing license'); } catch(e) {}
      return;
    }
    window.__lc_loaded = true;

    if (window.LiveChatWidget && LiveChatWidget.init) {
      LiveChatWidget.init();
      try { console.log('[LiveChat] init via', reason); } catch(e) {}
    } else {
      var s = document.createElement('script');
      s.async = true;
      s.defer = true;
      s.src = 'https://cdn.livechatinc.com/tracking.js';
      s.onload = function() {
        try {
          LiveChatWidget && LiveChatWidget.init && LiveChatWidget.init();
          console.log('[LiveChat] fallback init via', reason);
        } catch(e) {}
      };
      s.onerror = function() {
        try { console.error('[LiveChat] tracking.js failed to load'); } catch(e) {}
      };
      document.head.appendChild(s);
    }
  }

  // First interaction (any page)
  var first = function() {
    document.removeEventListener('click', first, false);
    document.removeEventListener('touchstart', first, false);
    document.removeEventListener('keydown', first, false);
    load('first-interaction');
  };
  document.addEventListener('click', first, false);
  document.addEventListener('touchstart', first, false);
  document.addEventListener('keydown', first, false);

  // Home bottom (index only) - set by template
  if (window.__ANB_IS_HOME) {
    try {
      var sent = document.getElementById('anb-livechat-bottom-sentinel');
      if ('IntersectionObserver' in window && sent) {
        var io = new IntersectionObserver(function(es) {
          if (es.some(function(e) { return e.isIntersecting; })) {
            io.disconnect();
            load('home-bottom');
          }
        }, { threshold: 0.2 });
        io.observe(sent);
      } else {
        var onScroll = function() {
          var d = document.documentElement, b = document.body;
          var sc = (d.scrollTop || b.scrollTop) + innerHeight;
          var h = d.scrollHeight || b.scrollHeight;
          if (sc >= h - 240) {
            removeEventListener('scroll', onScroll);
            load('home-bottom-fallback');
          }
        };
        addEventListener('scroll', onScroll, { passive: true });
      }
    } catch(e) {}
  }

  // Idle fallback (10s)
  (window.requestIdleCallback || function(cb) { return setTimeout(cb, 10000); })(function() {
    load('idle');
  });

  // Manual override
  try {
    var qp = new URLSearchParams(location.search);
    if (qp.get('chat') === '1') {
      setTimeout(function() { load('override'); }, 500);
    }
  } catch(e) {}
})();

